import { useAction, useAtom } from '@reatom/npm-react'

import { SegmentControl } from '@root/shared/ui-kit'

import {
  setTrendingStrategyAction,
  trendingStrategiesStateAtom,
  trendingStrategyAtom,
} from '../atoms'

import type { ClassNameProps } from '@root/shared/react'

/**
 * Which ranking the trending list is showing.
 *
 * The same control the tabs and the period beside it use, because it is the
 * same kind of choice and a toolbar with three different-looking switches in
 * it reads as three unrelated things. Loose chips were tried first and sat on
 * the bar like something dropped there.
 *
 * Absent while the server has not answered, and absent when it offers one way
 * to rank — a control with a single option is furniture.
 */
type Props = ClassNameProps

export const TrendingRankingChips: React.FC<Props> = ({ className }) => {
  const [state] = useAtom(trendingStrategiesStateAtom)
  const [strategy] = useAtom(trendingStrategyAtom)
  const setStrategy = useAction(setTrendingStrategyAction)

  const strategies = state.value ?? []
  if (strategies.length < 2) {
    return undefined
  }

  return (
    <SegmentControl
      className={className}
      value={strategy}
      onChange={setStrategy}
    >
      {strategies.map((item) => (
        <SegmentControl.Item key={item.id} value={item.id}>
          {item.label}
        </SegmentControl.Item>
      ))}
    </SegmentControl>
  )
}
